module.exports = function() {
  return new Worker(__webpack_public_path__ + "2c49c7a97f683e947453.worker.js");
};